export default __webpack_public_path__ + "static/media/design-color.8bfb591e.png";